// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__WFcI0","header":"ReportDetails_header__ObuU1","title":"ReportDetails_title__3cKmS","left":"ReportDetails_left__2VsOO"};